module.exports = __webpack_public_path__ + "static/media/more.5b5145fc.png";